import ws from '../../../libs/websocket';
export default {
    ws,
    terminal_names: [],
    onmessageCallback: null,
    timer1:0,
    timer2:0,
    config: null,
    refreshList (deviceList) {
        ws.on('on-reconnect', () => {
            if (this.timer1&&this.timer2) this.refreshList(this.terminal_names);
        })
        if (this.timer1) clearInterval(this.timer1);
        if (this.timer2) clearInterval(this.timer2);
        this.terminal_names = [];
        deviceList.forEach(device => {
            // 如果设备过期就不要发送
            if (device.terminal_id && device.terminal_id.trim().length && device.isExpire==1) {
                this.terminal_names.push(device.terminal_id);
            }
        })
        ws.onLiftMonitorConfig = this.onMonitorConfig.bind(this);
        ws.sendMessage('get_list_monitor_config');
        this.sendSubscribe();
    },
    onMonitorConfig(config) {
        if (this.terminal_names){
            let newWcrDeviceList=[];
            let DeviceList=[];
            ws.sendMessage('down_get_status_list', this.terminal_names);
            this.terminal_names.forEach(elem=>{
                if (elem.startsWith('W_')){
                    newWcrDeviceList.push(elem)
                } else{
                    DeviceList.push(elem)
                }
            })
            if (DeviceList&&DeviceList.length){
                this.timer1 = setInterval(() => {
                    ws.sendMessage('down_get_status_list', this.terminal_names);
                }, Math.max(config.timeout - 5000, 5000));
            }
            if (newWcrDeviceList&&newWcrDeviceList.length){ // wcr设备每隔20s主动要一次  like页面的数据
                ws.sendMessage('down_get_status_list', this.terminal_names);
                // this.timer2 = setInterval(() => {
                    this.timer2  = setInterval(()=>{
                        ws.sendMessage('down_get_status_list', this.terminal_names);
                    },20000)
                // }, Math.max(config.timeout - 20000, 20000));
            }
        }
    },
    sendSubscribe() {
        ws.addSubscibeToLift(this.terminal_names, 'subscribe')
        // ws.data.terminalNames = this.terminal_names
        // ws.sendMessage('subscribe', this.terminal_names);
    },
    destroy () {
        if (this.timer1) clearInterval(this.timer1);
        this.timer1 = 0;
        if (this.timer2) clearInterval(this.timer2);
        this.timer2 = 0;
        if (this.terminal_names.length) ws.addSubscibeToLift(this.terminal_names, 'cancel')
    },
    setFaultListener (listenerOccur, listenerSolved) {
        ws.on('up_report_fault', listenerOccur);
        ws.on('up_solve_fault', listenerSolved);
    },

}